import Vue from 'vue'
import VueRouter from 'vue-router'
import Overzicht from './views/Overzicht'
import Boeken from './views/Boeken'
import FlightFinder from './views/FlightFinder'
import CabinFinder from './views/CabinFinder'
import NotFound from './views/NotFound'

Vue.use(VueRouter)

// Adding a `?` behind a path makes the param optional
// Note that only one optional param can be used in a row

const routes = [
    {
        path: '/overzicht/:id/:departureDate?',
        name: 'Cruise',
        meta: { analytics: 'Overzicht' },
        component: Overzicht,
    },
    {
        path: '/overzicht/:id/:departureDate/:rate/:hutType?',
        name: 'CruiseRate',
        meta: { analytics: 'Overzicht' },
        component: Overzicht,
    },
    {
        path: '/overzicht/:id/:departureDate/:rate/:hutType/:hutCat',
        name: 'CruiseRateHut',
        meta: { analytics: 'Overzicht' },
        component: Overzicht,
    },
    {
        path: '/onlineboeken/:id/:departureDate?',
        name: 'Boeken',
        meta: { analytics: 'Overzicht' },
        component: Boeken,
    },
    {
        path: '/onlineboeken/:id/:departureDate/:rate/:hutType?',
        name: 'BoekenRate',
        meta: { analytics: 'Overzicht' },
        component: Boeken,
    },
    {
        path: '/onlineboeken/:id/:departureDate/:rate/:hutType/:hutCat',
        name: 'BoekenRateHut',
        meta: { analytics: 'Overzicht' },
        component: Boeken,
    },
    {
        path: '/flightfinder/:dossierID',
        name: 'FlightFinder',
        meta: { analytics: 'FlightFinder' },
        component: FlightFinder,
    },
    {
        path: '/flightfinder/:dossierID/:backend',
        name: 'FlightFinder',
        meta: { analytics: 'FlightFinder' },
        component: FlightFinder,
    },
    {
        path: '/cabinfinder/:dossierID/:cabinIndex',
        name: 'CabinFinder',
        meta: { analytics: 'CabinFinder' },
        component: CabinFinder,
    },
    {
        path: '*',
        name: 'NotFound',
        meta: { analytics: 'NotFound' },
        component: NotFound,
    },
]

const Router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})

const PAGE_TITLE = {
    Cruise: 'Cruise laagste prijs',
    CruiseRate: 'Cruise laagste prijs',
    CruiseRateHut: 'Cruise laagste prijs',
    CruiseDeparture: 'Cruise laagste prijs op Datum',
    CruiseDepartureCampagne: 'Cruise laagste prijs op Datum met Campagne',
    CruiseDepartureHutnummerCampagne:
        'Cruise laagste prijs op Datum, HutType met Campagne',
    Boeken: 'Online Boeken',
    BoekenRate: 'Online Boeken',
    BoekenRateHut: 'Online Boeken',
    FlightFinder: 'Flight Finder',
    CabinFinder: 'Cabin Finder',
    NotFound: 'Niet Gevonden',
}

Router.afterEach(toRoute => {
    window.document.title = 'CruiseReizen.nl - ' + PAGE_TITLE[toRoute.name]
})

export default Router
